import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const HeaderHeartIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19.23 1.56001C16.74 0.74001 13.88 1.59001 12 3.62001C10.11 1.58001 7.26004 0.74001 4.77004 1.56001C2.05004 2.44001 0.240041 4.97001 0.250041 7.84001C0.280041 14.71 6.42004 20.13 11.67 22.68C11.88 22.78 12.12 22.78 12.33 22.68C17.58 20.13 23.72 14.72 23.75 7.84001C23.76 4.97001 21.95 2.45001 19.23 1.56001ZM12 21.16C7.21004 18.74 1.78004 13.88 1.75004 7.83001C1.75004 5.61001 3.14004 3.67001 5.23004 2.98001C7.37004 2.28001 9.95004 3.23001 11.39 5.23001C11.67 5.64001 12.33 5.64001 12.61 5.23001C14.05 3.23001 16.63 2.28001 18.77 2.98001C20.86 3.67001 22.26 5.61001 22.25 7.83001C22.22 13.88 16.79 18.74 12 21.16Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HeaderHeartIcon.displayName = 'HeaderHeartIcon';
